import React, { createElement } from 'react';
// ---------------------------------------------------------------------------
// Performance hints injected into <head> at module-load time, before React
// mounts. Three goals:
//   1. Preconnect to the 3 most-critical origins (PageSpeed warns at >4)
//   2. Preload the Hero LCP image so it starts downloading immediately
//   3. Replace the CSS @import font waterfall with an early <link rel="stylesheet">
//      injected here, so Google Fonts CSS loads in parallel with our own CSS
// ---------------------------------------------------------------------------
if (typeof document !== 'undefined' && !(window as any).__mp_perf_hints) {
  ;
  (window as any).__mp_perf_hints = true;
  const head = document.head;
  const add = (rel: string, href: string, opts: Record<string, string> = {}) => {
    // Skip if a link with the same rel+href already exists (HMR / re-import safety)
    if (head.querySelector(`link[rel="${rel}"][href="${href}"]`)) return;
    const l = document.createElement('link');
    l.rel = rel;
    l.href = href;
    Object.entries(opts).forEach(([k, v]) => l.setAttribute(k, v));
    head.appendChild(l);
  };
  // 3 critical preconnects — PageSpeed warns above 4
  add('preconnect', 'https://fonts.googleapis.com');
  add('preconnect', 'https://fonts.gstatic.com', {
    crossorigin: 'anonymous'
  });
  add('preconnect', 'https://cdn.magicpatterns.com', {
    crossorigin: 'anonymous'
  });
  // Preload the Hero LCP image — highest priority asset on the page
  add('preload', 'https://cdn.magicpatterns.com/uploads/j6sRYcK5X4hdn124VLpYBV/Copia_de_Diseno_sin_titulo.png', {
    as: 'image',
    fetchpriority: 'high'
  });
  // Inject the Google Fonts stylesheet directly into <head> instead of relying
  // on the @import inside index.css. This breaks the CSS → @import → woff2
  // waterfall and lets the font CSS download in parallel with our app CSS.
  const FONT_CSS = 'https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@1,9..144,600;1,9..144,700&family=Inter:wght@400;500;600;700;800;900&family=Manrope:wght@600;700;800&display=swap';
  add('preload', FONT_CSS, {
    as: 'style'
  });
  add('stylesheet', FONT_CSS);
}
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { WhatsIncluded } from './components/WhatsIncluded';
import { ContentPreview } from './components/ContentPreview';
import { BonusStack } from './components/BonusStack';
import { PricingOptions } from './components/PricingOptions';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { WhatsAppFloat } from './components/WhatsAppFloat';
export function App() {
  return <div className="min-h-screen bg-clinical-base font-sans text-clinical-ink overflow-x-hidden" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <WhatsIncluded data-id="element-3" />
      <ContentPreview data-id="element-4" />
      <BonusStack data-id="element-5" />
      <PricingOptions data-id="element-6" />
      <Testimonials data-id="element-7" />
      <Guarantee data-id="element-8" />
      <FAQ data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
      <PurchaseNotifications data-id="element-12" />
      <WhatsAppFloat data-id="element-13" />
    </div>;
}